import React, { Component, Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col, Label, Input } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import { getPriceWithCurrencySymbol } from '../../../../utils/CommonUtils';

class ServiceFeesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFee: {
                id: -1,
                amount: null,
                inFavorOfRestaurant: false,
                tenderType: { 
                    id: -1,
                    value: 'Select type'
                }
            },
            tenderTypes: []
        }

        this.changeState = this.changeState.bind(this);
        this.submitData = this.submitData.bind(this);
    }
    
    componentDidMount() {
        const { id, amount, inFavorOfRestaurant, tenderType } = this.props.selectedFee;
        if (id) {
            this.setState({
                ...this.state,
                selectedFee: {
                    id: id,
                    amount: amount,
                    inFavorOfRestaurant: inFavorOfRestaurant,
                    tenderType: tenderType
                },
                tenderTypes: this.props.tenderTypes
            });
        }
    }

    submitData() {
        const { selectedFee } = this.state;

        if (selectedFee.amount) {
            this.props.submitData(selectedFee);
        }
    }

    renderContent() {
        const { serviceFeeCol, serviceFeeLabel, noPadding } = styles;

        const currency = this.props.restaurant.currency;
        const serviceFee = (this.state.selectedFee.amount === null) ? 0.00 : this.state.selectedFee.amount;
        const serviceFeePlaceholder = getPriceWithCurrencySymbol(serviceFee, currency);

        return (
            <Fragment>
                <AvGroup sm={12} style={serviceFeeCol}>
                    <Label sm={5} style={serviceFeeLabel}>{i18n.t('screens:paymentScreen.serviceFee')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvInput type="number" name="amount"
                            placeholder={serviceFeePlaceholder}
                            min={0}
                            required={true}
                            value={this.state.selectedFee.amount}
                            onChange={this.changeState} />
                    </Col>
                </AvGroup>

                <AvGroup sm={12} style={serviceFeeCol}>
                    <Label sm={5} style={serviceFeeLabel} for='inFavorOfRestaurant'>{i18n.t('screens:paymentScreen.inFavorOfRestaurant')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvField
                            type='checkbox'
                            id='inFavorOfRestaurant'
                            name="inFavorOfRestaurant"
                            style={{ top: 13, marginLeft: 0 }}
                            checked={this.state.selectedFee.inFavorOfRestaurant}
                            value={this.state.selectedFee.inFavorOfRestaurant}
                            onChange={this.changeState} />
                    </Col>
                </AvGroup>

                <AvGroup sm={12} style={serviceFeeCol}>
                    <Label sm={5} style={serviceFeeLabel} for='tenderType'>{i18n.t('screens:paymentScreen.applyToPayment')}</Label>
                    <Col sm={7} style={noPadding}>
                        <Input
                            type='select' name='tenderType'
                            required={true} onChange={this.changeState} value={this.state.selectedFee.tenderType.value}>
                            <option id={-1} value=''>{i18n.t('screens:paymentScreen.selectType')}</option>
                            {this.renderTenderTypeOptions()}
                        </Input>
                    </Col>
                </AvGroup>
            </Fragment>
        );
    }

    changeState({ target }) {
        this.setState({
            selectedFee: {
                ...this.state.selectedFee,
                [target.name]: target.name === 'tenderType' ? { id: parseInt(target.childNodes[target.selectedIndex].id), value: target.value }
                 : target.name === 'inFavorOfRestaurant' ?  !this.state.selectedFee.inFavorOfRestaurant : target.value
            }
        });
    }

    transformToLocalizeTenderTypes (value) {
        
        switch (value) {
            case "Credit card":
                return i18n.t(`common:paymentTypes.creditCard`);
            case "Cash":
                return i18n.t(`common:paymentTypes.cash`);
            default:
                return;
        }
    }

    renderTenderTypeOptions() {
        return this.props.tenderTypes.map(type => {
            return (
                <option key={`key${type.id}`} id={type.id} value={type.value}>{this.transformToLocalizeTenderTypes(type.value)}</option>
            );
        });
    }

    render() {
        const { amount, tenderType } = this.state.selectedFee;
        const isApplyBtnDisabled = amount && tenderType.id !== -1 ? false : true;

        return (
            <Modal isOpen={this.props.isOpen} toggle={() => this.props.toggle()}>
                <ModalHeader className="modalHeader" toggle={() => this.props.toggle(true)}>{i18n.t('screens:paymentScreen.selectPaymentType')}</ModalHeader>

                <ModalBody>
                    <AvForm>
                        {this.renderContent()}
                    </AvForm>
                </ModalBody>

                <ModalFooter>
                    {
                        this.props.feeIndex !== -1 ?
                            <Button
                                color="primary" outline style={{ display: 'flex', alignItems: 'center' }}
                                onClick={() => this.props.submitData(this.state.selectedFee, true)}>
                                <span style={{ marginBottom: 1 }}>
                                    <MaterialIcon icon="delete" color="#0288D1" size={18} />
                                </span>
                                {i18n.t('common:buttons.delete')}
                            </Button> : null
                    }
                    <Button color="primary" onClick={this.submitData} disabled={isApplyBtnDisabled}>
                        <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ServiceFeesModal;

let styles = {
    serviceFeeCol: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    serviceFeeLabel: {
        padding: '12px 16px 12px 0px'
    },
    noPadding: {
        padding: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/ServiceFeesModal.js